module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm._f("datetime")(_vm.value)))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c92b764"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DateTime.vue
// module id = 545
// module chunks = 1